// extracted by mini-css-extract-plugin
export default {"icon":"icon__srrkuiJ3","label":"label__IM22odcB"};